<template>
  <div class="app_intro">
    <h2>What you'll need:</h2>
    <ul>
      <li>Farm size and address</li>
      <li>Farm ownership/operation details</li>
      <li>Farm financials</li>
      <li>Personal information</li>
      <!-- <li>Documentation to support the above</li> -->
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>